import React from 'react';
import PropTypes from 'prop-types';

import PartnersSection from './PartnersSection';
import SectionAdvantages from './SectionAdvantages';
import SectionNav from './SectionNav';
import NewsSection from './NewsSection';

const Main = (props) => {
    return(
        <div>
            <div className="wrapper-content">
                <SectionNav defaultStaticContentNav={props.defaultStaticContentNav}
                            activeLangStaticContentNav={props.activeLangStaticContentNav}
                            defaultStaticContentMainPage={props.defaultStaticContentMainPage}
                            activeLangStaticContentMainPage={props.activeLangStaticContentMainPage}/>
            </div>
            <SectionAdvantages defaultStaticContentMainPage={props.defaultStaticContentMainPage}
                               activeLangStaticContentMainPage={props.activeLangStaticContentMainPage}/>
            <NewsSection defaultStaticContentNews={props.defaultStaticContentNews}
                         activeLangStaticContentNews={props.activeLangStaticContentNews}
                         activeLang={props.activeLang}/>
            <PartnersSection defaultStaticContentPartners={props.defaultStaticContentPartners}
                             activeLangStaticContentPartners={props.activeLangStaticContentPartners}/>
        </div>
       
    )
}

export default Main;

Main.propTypes = {
    activeLang: PropTypes.string,
    defaultStaticContentNav: PropTypes.object,
    activeLangStaticContentNav: PropTypes.object,
    defaultStaticContentMainPage: PropTypes.object,
    activeLangStaticContentMainPage: PropTypes.object,
    defaultStaticContentNews: PropTypes.object,
    activeLangStaticContentNews: PropTypes.object,
    defaultStaticContentPartners: PropTypes.object,
    activeLangStaticContentPartners: PropTypes.object,
}